import script from "./PandoraBtnChat.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraBtnChat.vue?vue&type=script&setup=true&lang=js"

import "./PandoraBtnChat.vue?vue&type=style&index=0&id=30cf11b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cf11b2"]])

export default __exports__